import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

type StockByPieceResponse = {
  price: number;
  pieceId: number;
  granitId: string;
};

type Dimensions = {
  x: number;
  y: number;
  z: number;
};

export const getStocksByPieceId = async (
  pieceId?: number,
  dimensions?: Dimensions,
): Promise<StockByPieceResponse[] | undefined> => {
  if (!pieceId || !dimensions) {
    return undefined;
  }
  const { data } = await api.get<StockByPieceResponse[]>(
    `/stock/piece/${pieceId}?x=${dimensions.x}&y=${dimensions.y}&z=${dimensions.z}`,
  );
  return data;
};

export const useStocksByPieceId = (
  pieceId?: number,
  dimensions?: Dimensions,
) => {
  return useQuery({
    queryKey: ['stocks-by-piece', pieceId, dimensions],
    queryFn: () => getStocksByPieceId(pieceId, dimensions),
    retry: false,
    enabled: !!pieceId && !!dimensions,
  });
};
